import React from 'react';
import { Card, CardTitle } from 'reactstrap';
import ButtonWithLoader from '../../../../core/components/ButtonWithLoader';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { showDialog } from '../../../../core/actions';
import { saveDetergentPod } from '../../../detergentsTemp/actions';
import Loader from '../../../../core/components/Loader';

interface Props {
  detergentPod: {
    id: number;
    description: string;
    title: string;
  };
  editDetergents: (detergentPod: any) => void;
}

const DetergentPodCard = (props: Props): JSX.Element => {
  const { detergentPod } = props;
  const intl: any = useIntl();
  const dispatch = useDispatch();
  const hideModal = () => dispatch({ type: 'HIDE_DIALOG' });
  const handleEditDetails = () => {
    const dialogProps = {
      onSubmit: saveDetergentPod,
      title: `${detergentPod.title} - ${intl.formatMessage({ id: 'editDetails' })}`,
      isNew: false,
      isOpen: true,
      hide: hideModal,
      detergentPod,
    };
    dispatch(showDialog('UPSERT_DETERGENT_POD', dialogProps));
  };

  return detergentPod ? (
    <Card
      body
      className="my-2"
      style={{
        borderRadius: '15px',
      }}
    >
      <div className="detergent-pod-card-header">
        <CardTitle className="chart-title">{detergentPod.title}</CardTitle>
        <i
          className="icon icon-edit"
          style={{ cursor: 'pointer' }}
          onClick={handleEditDetails}
          title={intl.formatMessage({ id: 'editPod' })}
        />
      </div>
      <p className="detergent-pod-description">{detergentPod.description}</p>
      <div style={{ marginTop: '10px' }}>
        <ButtonWithLoader
          handleClick={() => props.editDetergents(detergentPod)}
          style="detergent-action-button"
        >
          <span>{intl.formatMessage({ id: 'editContainers' })}</span>
        </ButtonWithLoader>
      </div>
    </Card>
  ) : (
    <Loader />
  );
};

export default DetergentPodCard;
